export const parseScreensharing = (screensharing?: string): string => screensharing ?? 'none'

export const hasScreenSharingPermission = (props: {
    isModerator: boolean,
    isOwner: boolean,
    isOperator: boolean,
    isAudienceChannel: boolean,
    screen_sharing?: 'agent' | 'customer' | 'member' | 'none' | string,
}): boolean => {
    const {
        isAudienceChannel, isModerator, isOwner, isOperator, screen_sharing,
    } = props

    const isAgent = isModerator || isOwner || isOperator
    if (!isAudienceChannel) {
        return true // for non-audience channels, everyone can screen share
    }
    switch (screen_sharing) {
        case 'agent': return isAgent
        case 'customer': return !isAgent
        case 'member': return true
        case 'none': return false
        default: return false
    }
}
